import Chip from '../Chip/Chip';
import CircleIcon from '@mui/icons-material/Circle';
import { Box, useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  rating: number;
  changeRating: (value: number) => void;
}

const Rate: FC<Props> = ({ rating, changeRating }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box>
      <Chip
        icon={<CircleIcon sx={{ color: `${theme.palette.success.main} !important` }} />}
        label={t('positive')}
        variant="outlined"
        onClick={() => changeRating(1)}
        sx={{
          backgroundColor: rating === 1 ? theme.palette.divider : 'none',
          borderColor: rating === 1 ? theme.palette.primary.main : 'none',
        }}
      />
      <Chip
        icon={<CircleIcon sx={{ color: `${theme.palette.secondary.main} !important` }} />}
        label={t('neutral')}
        variant="outlined"
        onClick={() => changeRating(2)}
        sx={{
          backgroundColor: rating === 2 ? theme.palette.divider : 'none',
          borderColor: rating === 2 ? theme.palette.primary.main : 'none',
        }}
      />
      <Chip
        icon={<CircleIcon sx={{ color: `${theme.palette.error.main} !important` }} />}
        label={t('negative')}
        variant="outlined"
        onClick={() => changeRating(3)}
        sx={{
          backgroundColor: rating === 3 ? theme.palette.divider : 'none',
          borderColor: rating === 3 ? theme.palette.primary.main : 'none',
        }}
      />
    </Box>
  );
};

export default Rate;
